<div class="card mb-5">
  <div class="card-body border-0 mt-2" *ngIf="!kids">
    <h5 class="text-primary">
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.MAKE_SURE.TITLE" | translate }}
    </h5>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.MAKE_SURE.CONTENT" | translate }}
    </p>
    <div class="d-flex justify-content-center">
      <img class="m-3" ngSrc="../../../assets/pre-prova-environment.svg" height="89" width="88"/>
    </div>
    <h5 class="text-primary">
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.ENVIRONMENT.TITLE" | translate }}
    </h5>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.ENVIRONMENT.CONTENT" | translate }}
    </p>
    <p>
      <span class="fw-bold">
        {{ "COL.LESSONS.DETAILS.PREPARE_TAB.ENVIRONMENT.EXAMPLES_GOOD_TITLE" | translate }}
      </span>
      <span>
        {{ "COL.LESSONS.DETAILS.PREPARE_TAB.ENVIRONMENT.EXAMPLES_GOOD_DESC" | translate }}
      </span>
      <br/>
      <span class="fw-bold">
        {{ "COL.LESSONS.DETAILS.PREPARE_TAB.ENVIRONMENT.EXAMPLES_BAD_TITLE" | translate }}
      </span>
      <span>
        {{ "COL.LESSONS.DETAILS.PREPARE_TAB.ENVIRONMENT.EXAMPLES_BAD_DESC" | translate }}
      </span>
    </p>
    <div class="d-flex justify-content-center">
      <img class="m-3" ngSrc="../../../assets/pre-prova-devices.svg" height="89" width="88"/>
    </div>
    <h5 class="text-primary">
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.CAMERA_MICROPHONE.TITLE" | translate }}
    </h5>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.CAMERA_MICROPHONE.CONTENT" | translate }}
    </p>
    <div class="d-flex justify-content-center">
      <img class="m-3" ngSrc="../../../assets/pre-prova-questions.svg" height="89" width="88"/>
    </div>
    <h5 class="text-primary">
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.NEED_HELP.TITLE" | translate }}
    </h5>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.NEED_HELP.CONTENT" | translate }}
    </p>
    <div class="d-flex justify-content-center">
      <button type="button" class="btn btn-primary rounded-pill px-3" (click)="contactUsModal.open()">
        {{ "NAVIGATION.CONTACT_US" | translate }}
      </button>
    </div>
  </div>
  <div class="card-body border-0 mt-2" *ngIf="kids">
    <h5 class="text-primary">
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.MAKE_SURE.TITLE" | translate }}
    </h5>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.MAKE_SURE.CONTENT_1" | translate }}
    </p>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.MAKE_SURE.CONTENT_2" | translate }}
    </p>
    <div class="d-flex justify-content-center">
      <img class="m-3" ngSrc="../../../assets/pre-prova-environment.svg" height="89" width="88"/>
    </div>
    <h5 class="text-primary">
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.ENVIRONMENT.TITLE" | translate }}
    </h5>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.ENVIRONMENT.CONTENT_1" | translate }}
    </p>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.ENVIRONMENT.CONTENT_2" | translate }}
    </p>
    <p>
      <span class="fw-bold">
        {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.ENVIRONMENT.EXAMPLES_GOOD_TITLE" | translate }}
      </span>
      <span>
        {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.ENVIRONMENT.EXAMPLES_GOOD_DESC" | translate }}
      </span>
      <br/>
      <span class="fw-bold">
        {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.ENVIRONMENT.EXAMPLES_BAD_TITLE" | translate }}
      </span>
      <span>
        {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.ENVIRONMENT.EXAMPLES_BAD_DESC" | translate }}
      </span>
    </p>
    <div class="d-flex justify-content-center">
      <img class="m-3" ngSrc="../../../assets/pre-prova-devices.svg" height="89" width="88"/>
    </div>
    <h5 class="text-primary">
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.CAMERA_MICROPHONE.TITLE" | translate }}
    </h5>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.CAMERA_MICROPHONE.CONTENT_1" | translate }}
    </p>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.CAMERA_MICROPHONE.CONTENT_2" | translate }}
    </p>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.CAMERA_MICROPHONE.CONTENT_3" | translate }}
    </p>
    <div class="d-flex justify-content-center">
      <img class="m-3" ngSrc="../../../assets/pre-prova-questions.svg" height="89" width="88"/>
    </div>
    <h5 class="text-primary">
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.NEED_HELP.TITLE" | translate }}
    </h5>
    <p>
      {{ "COL.LESSONS.DETAILS.PREPARE_TAB.KDS.NEED_HELP.CONTENT" | translate }}
    </p>
    <div class="d-flex justify-content-center">
      <button type="button" class="btn btn-primary rounded-pill px-3" (click)="contactUsModal.open()">
        {{ "NAVIGATION.CONTACT_US" | translate }}
      </button>
    </div>
  </div>
</div>
<app-contact-us-modal #contactUsModal></app-contact-us-modal>
